export enum CustomFieldType {
    TEXT = 0,
    NUMBER = 1,
    CHECKBOX = 2,
    DROP_DOWN = 3,
    AUTO_INCREMENT = 4,
}

/** A custom field as it rides along on a Cargo scan. */
export interface CustomField {
    Name: string;
    FieldType: CustomFieldType;
    Value: string | number | boolean;
    Id: number | string;
    Required?: boolean;
    Ready?: boolean;
    Icon?: string;
    Color?: string;
}

/** A custom field as defined by the organization in spectre-licensing. */
export interface CustomFieldDefinition {
    customFieldID: number;
    name: string;
    fieldType: CustomFieldType;
    required?: boolean;
    icon?: string;
    color?: string;
}

type SpectreAccentKey =
    | 'customFieldAccentText'
    | 'customFieldAccentNumber'
    | 'customFieldAccentCheckbox'
    | 'customFieldAccentDropdown'
    | 'customFieldAccentIncrement'
    | 'customFieldAccentDefault';

export interface CustomFieldTypeConfig {
    /** Key into theme.palette.spectre. */
    accent: SpectreAccentKey;
    /** Key into the custom field icon map. */
    icon: string;
}

const CUSTOM_FIELD_TYPE_CONFIG: Record<CustomFieldType, CustomFieldTypeConfig> = {
    [CustomFieldType.TEXT]: { accent: 'customFieldAccentText', icon: 'text' },
    [CustomFieldType.NUMBER]: { accent: 'customFieldAccentNumber', icon: 'numbers' },
    [CustomFieldType.CHECKBOX]: { accent: 'customFieldAccentCheckbox', icon: 'checkbox' },
    [CustomFieldType.DROP_DOWN]: { accent: 'customFieldAccentDropdown', icon: 'dropdown' },
    [CustomFieldType.AUTO_INCREMENT]: { accent: 'customFieldAccentIncrement', icon: 'increment' },
};

const UNKNOWN_CUSTOM_FIELD_TYPE_CONFIG: CustomFieldTypeConfig = { accent: 'customFieldAccentDefault', icon: 'label' };

export function customFieldTypeConfig(fieldType?: CustomFieldType): CustomFieldTypeConfig {
    return (fieldType != null && CUSTOM_FIELD_TYPE_CONFIG[fieldType]) || UNKNOWN_CUSTOM_FIELD_TYPE_CONFIG;
}
